import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { makeStyles } from '@material-ui/core/styles';
import ValidateUser from '../../components/UserStatus';
import SalesStreamContainer from '../../containers/SalesStream';
import { useTabVisibilityTracking } from '../../shared/utils/DatadogActiveTag';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#1F2128',
    minHeight: '100vh',
    padding: '10px',
  },
});

const SalesStream = () => {
  // Track via DD time spent by user on active tab
  useTabVisibilityTracking('sales-stream', 'sales-stream');

  // Create a separate QueryClient for this page
  const salesStreamQueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 2,
      },
    },
  });
  const classes = useStyles();
  return (
    <QueryClientProvider client={salesStreamQueryClient}>
      <div className={classes.root}>
        <ValidateUser />
        <SalesStreamContainer />
      </div>
    </QueryClientProvider>
  );
};

export default SalesStream;
